import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from './AuthForm';
import AuthManager from '../../../services/dashboard/AuthManager';
import { toast } from 'react-hot-toast';

export default function OtpVerification() {
  const [otp, setOtp] = useState(['', '', '', '', '', '']); // 6 digits
  const inputsRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const identifier = location.state?.identifier;

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, [identifier]);

  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    if (!val) return;
    const newOtp = [...otp];
    newOtp[idx] = val.charAt(val.length - 1);
    setOtp(newOtp);
    if (idx < 5) inputsRef.current[idx + 1].focus(); // 0-5 for 6 digits
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const newOtp = [...otp];
      if (otp[idx]) {
        newOtp[idx] = '';
        setOtp(newOtp);
      } else if (idx > 0) {
        inputsRef.current[idx - 1].focus();
        newOtp[idx - 1] = '';
        setOtp(newOtp);
      }
    }
  };

  const handleResend = async () => {
    try {
      const res = await AuthManager.requestPasswordResetOtp(identifier);

      if (res.errorCode) {
        toast.error(res.responseMessage || 'Something went wrong');
      } else {
        toast.success(res.responseMessage || 'Code resent successfully');
      }

    } catch (err) {
      toast.error('Network error, please try again');
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const code = otp.join('');
    if (code.length < 6) {
      toast.error('Please enter all 6 digits');
      return;
    }
    setLoading(true);
    try {
      const res = await AuthManager.verifyPasswordResetOtp(identifier, code);

      if (res.errorCode) {
        toast.error(res.responseMessage || 'Invalid OTP');
      } else {
        toast.success(res.responseMessage || 'OTP verified successfully');
        navigate('/change-password', { state: { identifier } });
      }

    } catch (err) {
      toast.error('Network error, please try again');
    } finally {
      setLoading(false);
    }
  };


  return (
    <AuthForm title="Verification" imageSrc="/images/otp img.svg">
      <form className="space-y-4 max-w-md mx-auto" onSubmit={handleSubmit}>
        <p className="text-center">Enter your 6 digit code that you received on your email.</p>

        <div className="flex justify-center gap-4 flex-wrap">
          {otp.map((digit, idx) => (
            <input
              key={idx}
              ref={el => (inputsRef.current[idx] = el)}
              type="text"
              maxLength={1}
              value={digit}
              onChange={e => handleChange(e, idx)}
              onKeyDown={e => handleKeyDown(e, idx)}
              className="w-12 h-12 border border-[#FF7236] rounded text-center text-xl focus:outline-none focus:border-[#FF7236]"
            />
          ))}
        </div>

        <div className="text-center text-sm">
          Didn't receive a code?{' '}
          <button type="button" onClick={handleResend} className="text-[#FF7236] underline">
            Resend
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#FF7236] hover:bg-[#EB5E22] text-white py-2 rounded disabled:opacity-50"
        >
          {loading ? 'Verifying...' : 'Verify'}
        </button>
      </form>
    </AuthForm>
  );
}
